<div class="create-role">
  <!-- Form Container -->
  <div class="container-custom">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <app-breadcrumb [breadcrumbItems]="breadcrumbItems"></app-breadcrumb>
      </div>
      <span class="fa fa-times close_icon" (click)="closeModal()"></span>
    </div>
    <div class="d-flex justify-content-between align-items-center role-header">
      <div>
        <span class="title">Create Research Studies</span>
      </div>
    </div>
    <div class="my-4">
      <p>Please fill the below information to create research studies.</p>
    </div>
    <!-- Form Fields -->
    <form [formGroup]="researchStudiesForm" (ngSubmit)="onSubmit()">
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label">Enter Study Name*</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Study Name"
            formControlName="study_name"
          />
          <small
            *ngIf="
              researchStudiesForm.get('study_name')?.invalid &&
              researchStudiesForm.get('study_name')?.touched
            "
            class="text-danger"
          >
            <span
              *ngIf="
                researchStudiesForm.get('study_name')?.errors?.['required']
              "
              >Study name is required.</span
            >
            <span
              *ngIf="
                researchStudiesForm.get('study_name')?.errors?.['maxlength']
              "
              >Study name cannot exceed 100 characters.</span
            >
          </small>
        </div>
        <div class="col-md-6">
          <label class="form-label">By Whom*</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Department Name"
            formControlName="by_whom"
          />
          <small
            *ngIf="
              researchStudiesForm.get('by_whom')?.invalid &&
              researchStudiesForm.get('by_whom')?.touched
            "
            class="text-danger"
          >
            <span
              *ngIf="researchStudiesForm.get('by_whom')?.errors?.['required']"
              >By whom name is required.</span
            >
            <span
              *ngIf="researchStudiesForm.get('by_whom')?.errors?.['maxlength']"
              >By whom name cannot exceed 100 characters.</span
            >
          </small>
        </div>
        <div class="col-md-6">
          <label class="form-label">Title*</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Department Name"
            formControlName="registry_title"
          />
          <small
            *ngIf="
              researchStudiesForm.get('registry_title')?.invalid &&
              researchStudiesForm.get('registry_title')?.touched
            "
            class="text-danger"
          >
            <span
              *ngIf="
                researchStudiesForm.get('registry_title')?.errors?.['required']
              "
              >By whom name is required.</span
            >
            <span
              *ngIf="
                researchStudiesForm.get('registry_title')?.errors?.['maxlength']
              "
              >By whom name cannot exceed 100 characters.</span
            >
          </small>
        </div>
        <div class="col-md-4">
          <label class="form-label">Duration*</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Duration Time"
            formControlName="duration_of_study"
          />
          <small
            *ngIf="
              researchStudiesForm.get('duration_of_study')?.invalid &&
              researchStudiesForm.get('duration_of_study')?.touched
            "
            class="text-danger"
          >
            <span
              *ngIf="
                researchStudiesForm.get('duration_of_study')?.errors?.[
                  'required'
                ]
              "
              >Enter Duration Time required.</span
            >
            <!-- <span *ngIf="researchStudiesForm.get('register_title')?.errors?.['maxlength']">By whom name cannot exceed
                            100 characters.</span> -->
          </small>
        </div>
        <div class="col-md-2">
          <select class="form-select align" formControlName="duration_unit">
            <option value="month">Month</option>
            <option value="year">Year</option>
          </select>
          <small
            *ngIf="
              researchStudiesForm.get('duration_unit')?.invalid &&
              researchStudiesForm.get('duration_unit')?.touched
            "
            class="text-danger"
          >
            <span *ngIf="researchStudiesForm.get('duration_unit')?.errors?.['required']">Select duration unit.</span>
            <!-- <span *ngIf="researchStudiesForm.get('register_title')?.errors?.['maxlength']">By whom name cannot exceed
                            100 characters.</span> -->
          </small>
        </div>
        <div class="col-md-12 mt-3">
          <label class="form-label">Who Can Join*</label>

          <div class="chip-input-container">
            <div class="chips">
              <span
                class="chip"
                *ngFor="let item of whoCanJoinList; let i = index"
              >
                {{ item }}
                <span class="remove-chip" (click)="removeChip(i)">×</span>
              </span>

              <input
                type="text"
                class="chip-input"
                placeholder="Type and press Enter"
                (keydown.enter)="addChip($event)"
                (blur)="addChipOnBlur($event)"
              />
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">Global Tag*</label>
          <app-single-select-dropdown
            formControlName="global_tag_id"
            [list]="globalTagList || []"
            [displayKey]="'tag_name'"
            [valueKey]="'id'"
            placeholder="Global Tag"
          >
          </app-single-select-dropdown>
          <small
            *ngIf="
              researchStudiesForm.get('global_tag_id')?.invalid &&
              researchStudiesForm.get('global_tag_id')?.touched
            "
            class="text-danger"
          >
            <span
              *ngIf="
                researchStudiesForm.get('global_tag_id')?.errors?.['required']
              "
            >
              Global Tag is required.</span
            >
          </small>
        </div>
        <div class="col-md-12 mt-3">
          <label class="form-label">Upload Document</label>
          <input
            #documentUploadInput
            type="file"
            class="d-none"
            accept=".xlsx,.xls"
            (change)="onDocumentsSelected($event)"
            formControlName="completion_config"
          />
          <div
            *ngIf="showUploadDocumentField"
            class="upload-document-field"
            role="button"
            tabindex="0"
            (click)="documentUploadInput.click()"
          >
            <input
              type="text"
              class="form-control upload-input"
              placeholder="Upload .xlsx or .xls file"
              readonly
            />
            <img
              src="../../../../assets/svg/Upload.svg"
              class="upload-document-icon"
              aria-hidden="true"
            />
          </div>
          <div class="uploaded-document-list" *ngIf="uploadedDocuments.length">
            <div
              class="uploaded-document-card"
              *ngFor="let document of uploadedDocuments; let i = index"
            >
              <div class="uploaded-document-meta">
                <div class="uploaded-document-badge">
                  <img
                    src="../../../../assets/svg/vector.svg"
                    class="fa fa-file-text-o"
                    aria-hidden="true"
                  />
                </div>
                <div class="uploaded-document-copy">
                  <div class="uploaded-document-name">
                    {{ document.file.name }}
                  </div>
                  <div class="uploaded-document-size">
                    {{ formatFileSize(document.file.size) }}
                  </div>
                </div>
              </div>
              <div class="uploaded-document-actions">
                <button
                  type="button"
                  class="document-action-button"
                  (click)="viewDocument(document)"
                  title="View"
                >
                  <img
                    src="../../../../assets/svg/view_pdf.svg"
                    class="fa fa-eye"
                    aria-hidden="true"
                  />
                </button>
                <button
                  type="button"
                  class="document-action-button"
                  (click)="downloadDocument(document)"
                  title="Download"
                >
                  <img
                    src="../../../../assets/svg/dw_pdf.svg"
                    class="fa fa-download"
                    aria-hidden="true"
                  />
                </button>
                <button
                  type="button"
                  class="document-action-button"
                  (click)="removeDocument(i)"
                  title="Delete"
                >
                  <img
                    src="../../../../assets/svg/del_pdf.svg"
                    class="fa fa-trash-o"
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>
            <button
              type="button"
              class="add-another-document"
              (click)="showUploadField()"
            >
              <span class="fa fa-plus" aria-hidden="true"></span>
              Add another document
            </button>
          </div>
          <div class="completion-config-viewer" *ngIf="showCompletionConfigViewer">
            <label class="form-label mb-2">Completion Config JSON</label>
            <pre class="completion-config-json">{{ completionConfigViewerData | json }}</pre>
          </div>
        </div>
      </div>

      <!-- Toggles -->
      <div class="mt-3">
        <div class="d-flex align-items-center mb-2">
          <label class="form-check-label me-2">Deleted Status</label>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              formControlName="deleted"
            />
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="footer-buttons mt-3">
        <div class="d-flex align-items-center mt-3 gap-3">
          <button
            class="btn btn-outline-secondary mt-3"
            (click)="closeModal()"
            type="button"
          >
            Cancel
          </button>
          <button class="btn btn-create mt-3" type="submit">Save</button>
        </div>
      </div>
    </form>
  </div>
</div>
